export enum ActivityFilterType {
    StartDate = 'startDate',
    EndDate = 'endDate',
    User = 'eid',
    Group = 'groupId',
    Subgroup = 'subgroupId',
    SessionId = 'sessionId',
    UserInfoId = 'userInfoId',
    Result = 'result',
    ResultInformation = 'resultInformation',
    ClientDevice = 'clientDevice',
    FilePipelineStatus = 'filePipelineStatus',
}

export enum ActivityChartType {
    Total = 'total',
    SessionResult = 'session_result',
    FilePipelineStatus = 'file_pipeline_status',
    AvgDuration = 'avg_duration'
}

export enum ActivityMetric {
    Total = 'total',
    UniqueVisitors = 'uniqueClients',
    Missed = 'missed',
    Answered = 'answered',
    Successful = 'successful',
    Failed = 'failed',
    NoResult = 'noResult',
    SessionFlowTotal = 'sessionFlowTotal',
    EscalationAnswered = 'escalationAnswered',
    EscalationMissed = 'escalatedMissed',
    SelfResolved = 'selfResolved',
    AllFilesProcessed = 'allFilesProcessed',
    SomeFilesUnprocessed = 'someFilesUnprocessed',
    NoFilesForProcessing = 'noFilesForProcessing',
    AvgResponseTime = 'avgResponseTime',
    AvgDuration = 'avgDuration',
    UnsuccessfulSessionResultDetails = 'unsuccessfulSessionsResultDetails',
    SuccessfulSessionResultDetails = 'successfulSessionResultDetails',
    ClientDeviceBrowser = 'device.browser',
    ClientDeviceAndroidSdk = 'device.android-sdk',
    ClientDeviceIosSDK = 'device.ios-sdk',
    ClientDeviceSip = 'device.sip',
    ClientDevicePhone = 'device.phone',
}

export const ActivityMetricDefaultColor = '#E0E0E0';
export const ActivityMetricColor = {
    [ActivityMetric.Total]: '#58b5e1', // ?
    [ActivityMetric.UniqueVisitors]: '#00A3FF',
    [ActivityMetric.Missed]: '#FCCA1E',
    [ActivityMetric.Answered]: '#6FCF97',
    [ActivityMetric.Successful]: '#27AE60',
    [ActivityMetric.Failed]: '#EB5757',
    [ActivityMetric.SessionFlowTotal]: '#58b5e1', // ?
    [ActivityMetric.EscalationAnswered]: '#6FCF97',
    [ActivityMetric.EscalationMissed]: '#EB5757',
    [ActivityMetric.SelfResolved]: '#58b5e1',
    [ActivityMetric.AllFilesProcessed]: '#9660DD',
    [ActivityMetric.SomeFilesUnprocessed]: '#4F6290',
    [ActivityMetric.NoFilesForProcessing]: ActivityMetricDefaultColor,
    [ActivityMetric.AvgResponseTime]: '#58b5e1', // ?
    [ActivityMetric.AvgDuration]: '#4F6290',
    [ActivityMetric.ClientDeviceBrowser]: '#58b5e1',
    [ActivityMetric.ClientDeviceAndroidSdk]: '#6FCF97',
    [ActivityMetric.ClientDeviceIosSDK]: '#4F6290',
    [ActivityMetric.ClientDeviceSip]: '#FCCA1E',
    [ActivityMetric.ClientDevicePhone]: '#9660DD',
};
